import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import type { AppDispatch } from 'store/store';
import { authGoogleLogin } from 'store/authSlice';

export const GoogleLogMe: React.FC = () => {
  const [logging, setLogging] = useState<boolean>(true);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const doLogin = async () => {
      try {
        setLogging(true);
        const accessToken = searchParams.get('accessToken');
        const refreshToken = searchParams.get('refreshToken');

        if (!accessToken) {
          throw new Error('No access token received from server');
        }

        await dispatch(
          authGoogleLogin({ accessToken, refreshToken: refreshToken ?? '' }),
        ).unwrap();
        const returnUrl = searchParams.get('returnUrl') || '/app';
        navigate(returnUrl);
      } finally {
        setLogging(false);
      }
    };

    void doLogin(); // Prevent unhandled promise lint warning
  }, [dispatch, navigate, searchParams]);

  return (
    <>
      {logging ? (
        <div>Wait while we redirect you...</div>
      ) : (
        <div>
          <p>Redirecting...</p>
        </div>
      )}
    </>
  );
};
